import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import Chat from "../components/Chat";

const Careers = () => {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [applicationMode, setApplicationMode] = useState("email"); // "email" or "form"
  const [waitlistData, setWaitlistData] = useState({
    name: "",
    email: "",
    expertise: "",
    cv: null,
  });
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    const fetchJobs = async () => {
      try {
        const res = await fetch("/api/v1/jobs/list");
        if (!res.ok) throw new Error("No endpoint");
        const data = await res.json();
        if (Array.isArray(data)) setJobs(data);
        else setJobs([]);
      } catch (err) {
        setJobs([]);
      } finally {
        setLoading(false);
      }
    };
    fetchJobs();
  }, []);

  const handleWaitlistChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "cv") {
      setWaitlistData((prev) => ({ ...prev, cv: files[0] }));
    } else {
      setWaitlistData((prev) => ({ ...prev, [name]: value }));
    }
  };

  // Mock submission – shows success alert, no backend required
  const handleWaitlistSubmit = (e) => {
    e.preventDefault();
    setSubmitting(true);

    // Simulate a short delay for UX
    setTimeout(() => {
      Swal.fire({
        icon: "success",
        title: "CV Received!",
        text: "Thank you for your interest. We’ll keep your details on file and reach out if a suitable position opens.",
      });
      setWaitlistData({ name: "", email: "", expertise: "", cv: null });
      setSubmitting(false);
    }, 800);
  };

  return (
    <>
      <style>{`
        .careers-hero {
          background: url('https://images.unsplash.com/photo-1504917595217-d4dc5ebe6122?w=1200') center/cover no-repeat;
          padding: 120px 0 80px;
          position: relative;
          text-align: center;
          color: #fff;
        }
        .careers-hero::before {
          content: '';
          position: absolute;
          inset: 0;
          background: rgba(0,0,0,0.55);
        }
        .careers-hero .container {
          position: relative;
          z-index: 2;
        }
        .careers-hero h1 {
          font-size: 2.8rem;
          font-weight: 700;
          margin-bottom: 1rem;
        }
        .careers-hero p {
          font-size: 1.1rem;
          max-width: 650px;
          margin: 0 auto;
          color: rgba(255,255,255,0.9);
        }

        .why-sagama-section {
          background: #f9f9f9;
          padding: 3rem 0;
        }
        .why-sagama-section h2 {
          color: #0a1a3d;
          font-weight: 600;
          margin-bottom: 1.5rem;
        }
        .why-sagama-section p {
          color: #555;
          font-size: 1rem;
          line-height: 1.8;
          max-width: 800px;
          margin: 0 auto;
        }

        .open-positions-section {
          padding: 3rem 0;
        }
        .section-title {
          text-align: center;
          margin-bottom: 2rem;
        }
        .section-title h2 {
          font-size: 2rem;
          color: #0a1a3d;
          font-weight: 700;
        }

        .no-openings {
          background: #fff;
          border-radius: 16px;
          box-shadow: 0 8px 24px rgba(0,0,0,0.06);
          padding: 3rem 2rem;
          text-align: center;
          max-width: 550px;
          margin: 0 auto;
        }
        .no-openings h3 {
          color: #0a1a3d;
          margin-bottom: 1rem;
        }
        .no-openings p {
          color: #666;
          margin-bottom: 2rem;
        }
        .btn-primary-careers {
          background: #e86b24;
          color: #fff;
          border: none;
          padding: 12px 28px;
          border-radius: 50px;
          font-weight: 600;
          cursor: pointer;
          transition: background 0.3s;
          text-decoration: none;
          display: inline-block;
        }
        .btn-primary-careers:hover {
          background: #d2551a;
        }
        .btn-primary-careers:disabled {
          opacity: 0.7;
          cursor: not-allowed;
        }

        .mode-switcher {
          display: flex;
          justify-content: center;
          gap: 15px;
          margin: 2rem 0;
        }
        .mode-btn {
          padding: 10px 25px;
          border-radius: 50px;
          border: 2px solid #e86b24;
          background: transparent;
          color: #e86b24;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s;
        }
        .mode-btn.active, .mode-btn:hover {
          background: #e86b24;
          color: #fff;
        }

        .email-application {
          background: #fff;
          border-radius: 16px;
          padding: 2rem;
          box-shadow: 0 8px 24px rgba(0,0,0,0.06);
          text-align: center;
          max-width: 500px;
          margin: 0 auto;
        }
        .email-application h4 {
          color: #0a1a3d;
          margin-bottom: 1rem;
        }
        .email-application p {
          color: #666;
          margin-bottom: 1.5rem;
        }
        .email-btn {
          background: #e86b24;
          color: #fff;
          padding: 12px 30px;
          border-radius: 50px;
          font-weight: 600;
          text-decoration: none;
          display: inline-flex;
          align-items: center;
          gap: 8px;
          transition: background 0.3s, transform 0.2s;
        }
        .email-btn:hover {
          background: #d2551a;
          transform: translateY(-2px);
        }

        .form-application {
          background: #fff;
          border-radius: 16px;
          box-shadow: 0 8px 24px rgba(0,0,0,0.06);
          padding: 2rem;
          max-width: 500px;
          margin: 0 auto;
          text-align: left;
        }
        .form-group {
          margin-bottom: 1.5rem;
          display: flex;
          align-items: center;
          gap: 10px;
        }
        .form-group i {
          color: #aaa;
          width: 20px;
          text-align: center;
        }
        .form-control {
          flex: 1;
          padding: 10px 15px;
          border: 1px solid #e0e0e0;
          border-radius: 10px;
          font-size: 0.95rem;
          background: #fafafa;
        }
        .form-control:focus {
          border-color: #e86b24;
          box-shadow: 0 0 0 3px rgba(232,107,36,0.1);
          outline: none;
        }
        .file-input-wrapper {
          display: flex;
          align-items: center;
          gap: 10px;
        }
        .file-input-wrapper i {
          color: #aaa;
          width: 20px;
          text-align: center;
        }
        .file-input-wrapper input[type="file"] {
          flex: 1;
          padding: 8px;
          border: 1px solid #e0e0e0;
          border-radius: 10px;
          background: #fafafa;
        }

        .hiring-process-section {
          background: #f9f9f9;
          padding: 3rem 0;
        }
        .process-steps {
          display: flex;
          justify-content: center;
          gap: 30px;
          flex-wrap: wrap;
        }
        .process-step {
          flex: 1 1 250px;
          max-width: 280px;
          background: #fff;
          border-radius: 12px;
          padding: 30px 20px;
          text-align: center;
          box-shadow: 0 5px 15px rgba(0,0,0,0.05);
        }
        .process-step .step-number {
          font-size: 1.8rem;
          font-weight: 700;
          color: #e86b24;
        }
        .process-step h4 {
          margin: 1rem 0 0.5rem;
          color: #0a1a3d;
        }
        .process-step p {
          color: #555;
          font-size: 0.9rem;
        }

        @media (max-width: 768px) {
          .careers-hero h1 {
            font-size: 2rem;
          }
        }
      `}</style>

      <div className="careers-hero">
        <div className="container">
          <h1>Build the Future with Sagama</h1>
          <p>Great projects need great people. Is that you?</p>
        </div>
      </div>

      <section className="why-sagama-section">
        <div className="container text-center">
          <h2>Why Sagama?</h2>
          <p>
            We don’t just construct buildings; we build legacies. At Sagama,
            you’ll work at the intersection of high-end real estate and precision
            engineering. We offer a fast-paced environment where your expertise
            is valued, your voice is heard, and your professional growth is our
            priority.
          </p>
        </div>
      </section>

      <section className="open-positions-section">
        <div className="container">
          <div className="section-title">
            <h2>Open Positions</h2>
          </div>

          {loading ? (
            <div className="text-center py-5">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : jobs.length > 0 ? (
            <div className="row g-4 justify-content-center">
              {jobs.map((job, idx) => (
                <div className="col-md-6 col-lg-4" key={idx}>
                  <div className="card h-100 border-0 shadow-sm">
                    <div className="card-body">
                      <h5 className="card-title">{job.title}</h5>
                      <p className="card-text text-muted">{job.location}</p>
                      <button className="btn-primary-careers">Apply Now</button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="no-openings">
              <h3>We’re currently at full capacity for our core team.</h3>
              <p>However, we are always scouting for top‑tier talent.</p>

              <div className="mode-switcher">
                <button
                  className={`mode-btn ${applicationMode === "email" ? "active" : ""}`}
                  onClick={() => setApplicationMode("email")}
                >
                  Quick Email Application
                </button>
                <button
                  className={`mode-btn ${applicationMode === "form" ? "active" : ""}`}
                  onClick={() => setApplicationMode("form")}
                >
                  Full Form
                </button>
              </div>

              {applicationMode === "email" && (
                <div className="email-application">
                  <h4>Apply via Email</h4>
                  <p>
                    Click the button below to open your email client. You can
                    attach your CV and write a brief introduction.
                  </p>
                  <a
                    href="mailto:sagamaconstruction125@gmail.com?subject=CV%20Application&body=Dear%20Hiring%20Team,%0D%0A%0D%0APlease%20find%20attached%20my%20CV%20for%20consideration.%20I%20am%20interested%20in%20future%20opportunities%20at%20Sagama.%0D%0A%0D%0AThank%20you."
                    className="email-btn"
                    target="_self"
                  >
                    <i className="fas fa-envelope"></i> Send CV via Email
                  </a>
                </div>
              )}

              {applicationMode === "form" && (
                <div className="form-application">
                  <form onSubmit={handleWaitlistSubmit}>
                    <div className="form-group">
                      <i className="fal fa-user"></i>
                      <input
                        type="text"
                        className="form-control"
                        name="name"
                        placeholder="Full Name"
                        value={waitlistData.name}
                        onChange={handleWaitlistChange}
                        required
                      />
                    </div>
                    <div className="form-group">
                      <i className="fal fa-envelope"></i>
                      <input
                        type="email"
                        className="form-control"
                        name="email"
                        placeholder="Email Address"
                        value={waitlistData.email}
                        onChange={handleWaitlistChange}
                        required
                      />
                    </div>
                    <div className="form-group">
                      <i className="fal fa-briefcase"></i>
                      <input
                        type="text"
                        className="form-control"
                        name="expertise"
                        placeholder="Area of Expertise"
                        value={waitlistData.expertise}
                        onChange={handleWaitlistChange}
                        required
                      />
                    </div>
                    <div className="form-group">
                      <div className="file-input-wrapper">
                        <i className="fal fa-upload"></i>
                        <input
                          type="file"
                          name="cv"
                          accept=".pdf,.doc,.docx"
                          onChange={handleWaitlistChange}
                        />
                      </div>
                      <small className="text-muted">Upload your CV (PDF, DOC)</small>
                    </div>
                    <button type="submit" className="btn-primary-careers w-100" disabled={submitting}>
                      {submitting ? "Sending..." : "Send CV"}
                    </button>
                  </form>
                </div>
              )}
            </div>
          )}
        </div>
      </section>

      <section className="hiring-process-section">
        <div className="container">
          <div className="section-title">
            <h2>Our Hiring Process</h2>
            <p className="text-muted">We keep it simple, respectful, and fast.</p>
          </div>
          <div className="process-steps">
            <div className="process-step">
              <div className="step-number">01</div>
              <h4>Application</h4>
              <p>You send us your details. We review them thoroughly.</p>
            </div>
            <div className="process-step">
              <div className="step-number">02</div>
              <h4>Review</h4>
              <p>Our team evaluates your skills and experience.</p>
            </div>
            <div className="process-step">
              <div className="step-number">03</div>
              <h4>Conversation</h4>
              <p>If there’s a match, we schedule an interview to discuss how you can contribute to the Sagama vision.</p>
            </div>
          </div>
        </div>
      </section>

      <Chat />
    </>
  );
};

export default Careers;